export default __webpack_public_path__ + "static/media/ISKO CLASS-9 EXAM PATTERN 2025.0f2d07cc.pdf";